import React, { useState, useEffect } from 'react'
import { HomeIcon, PencilIcon, BuildingLibraryIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { 
  Typography,
  Card,
  CardBody,
  Input,
  Slider,
  Button,
  Spinner,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel, 
  slider
} from "@material-tailwind/react";

import {
  Routes,
  Route,
  useNavigate,
  Link
} from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RecoverTapToken from './RecoverTapToken';
import RecoverTransfer from './RecoverTransfer';
import RecoverDmtToken from './RecoverDmtToken';
import RecoverBrc20 from './RecoverBrc20';
import Mint from './Mint';
import Runes from './Runes';
import RecoverBrc20Claim from './RecoverBrc20Claim';
import Alkanes from './Alkanes';
import OP20 from './Op20';
import OP20Domain from './RecoverOp20Domain';

export default function Indexer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tab, setTab] = useState(0); //0: Wallet 1: Mint Domain 2: Explorer
  
  const handleTab = (tab) => {
    setTab(tab);
    switch(tab) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/tap');
        break;
      case 2:
        navigate('/transfer');
        break;
      case 3:
        navigate('/dmt');
        break;
      case 4:
        navigate('/rune');
        break;
      case 5:
        navigate('/brc20');
        break;
      case 6:
        navigate('/brc20claim');
        break;
      case 7:
        navigate('/alkanes');
        break;
      case 8:
        navigate('/op20');
        break;
      case 9:
        navigate('/op20domain');
        break;
    }
  }
  return (
    <div className="flex flex-col gap-5 bg-background items-center w-full">
      <Header tab = {tab} handle = { handleTab}/>
      <Routes>
        <Route path="/" element={<Mint />} />
        <Route path="/tap" element={<RecoverTapToken />} />
        <Route path="/transfer" element={<RecoverTransfer />} />
        <Route path="/dmt" element={<RecoverDmtToken />} />
        <Route path="/rune" element={<Runes />} />
        <Route path="/brc20" element={<RecoverBrc20 />} />
        <Route path="/brc20claim" element={<RecoverBrc20Claim />} />
        <Route path="/alkanes" element={<Alkanes />} />
        <Route path="/op20" element={<OP20 />} />
        <Route path="/op20domain" element={<OP20Domain />} />
      </Routes>
      <Footer />
    </div>
  )
}
